<template>
    <div class="clearfix">
        <compFormEdit ref="form" v-model="formData" :formdata="getBase"></compFormEdit>
        <div class="margin-15 pull-right">
            <Button class="margin-right-15" type="success" @click="submit">提交</Button>
            <Button type="default" @click="$emit('on-close')">取消</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpChangeArriveDate
} from "@/service/headlogistics";
export default {
    props: ['originData'],
    data () {
        return {
            loading: false,
            formData: {}
        }
    },
    computed: {
        getBase () {
            return [
                {
                    label: '最新预计到仓时间',
                    key: 'newestEstimateArriveDate',
                    tag: 'vDatepicker',
                    props:{
                        format:'yyyy-mm-dd',
                        confirm:false,
                    },
                    style: {
                        'width': '300px'
                    },
                    required: true
                }
            ]
        },
    },
    methods: {
        async submit () {
            let flag = await this.$refs.form.validate();
            if (!flag) return;
            this.loading = true;
            await HttpChangeArriveDate({
                id: this.originData.id,
                newestEstimateArriveDate: this.formData.newestEstimateArriveDate
            }).then(res => {
                this.$VMessage.success(res.message);
                this.$emit('on-success');
                this.$emit('on-close');
            }, err => {
                this.$VMessage.error(err.message);
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>

<style>

</style>